export default __webpack_public_path__ + "static/media/pearl-logo.42aeaf56.svg";